import api from '../../../../api';

export const BadgeSelector = {
  BADGE: api.internals.ns.selector('badge')
};
